import React from 'react'
import { browserHistory, Route, Router } from 'react-router'
import Restaurant from './Page/Restaurant'
import Etablissement from './Page/Etablissement'
import CRM from './Page/CRM'
import Interface from './Page/Interface'
import Pedagogie from './Page/Pedagogie'
import Facturation from './Page/Facturation'
import Gestion from './Page/Gestion'
import SDD from './Page/SDD'
import Hotel from './Page/Hotel'

export default _ =>
  <Router history={browserHistory}>
    <Route path="/configuration/crm" component={CRM} />
    <Route path="/configuration/gestion" component={Gestion} />
    <Route path="/configuration/restaurant" component={Restaurant} />
    <Route path="/configuration/hotel" component={Hotel} />
    <Route path="/configuration/sdd" component={SDD} />
    <Route path="/configuration/etablissement" component={Etablissement} />
    <Route path="/configuration/interface" component={Interface} />
    <Route path="/configuration/pedagogie" component={Pedagogie} />
    <Route path="/configuration/facturation" component={Facturation} />
  </Router>



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/index.js